import { MemberService } from './../../member/member.service'
import { employeeBookingActions } from './../../employee-booking/employee-booking.actions'
import { RoundMinutesPipe } from './../../../shared/pipes/round-minutes.pipe'
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import moment from 'moment-mini'
import {
  BehaviorSubject,
  combineLatest,
  Observable,
  of,
  Subject,
  Subscription
} from 'rxjs'
import {
  distinctUntilChanged,
  filter,
  first,
  map,
  startWith,
  switchMap,
  take,
  withLatestFrom
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { BulkAction, BulkActionEvent } from 'src/app/shared/interfaces'
import { ConfigurationService } from '../../../shared/services/configuration.service'
import { Member } from '../../member/member'
import { memberSelectors } from '../../member/member.selectors'
import {
  SupervisorBooking,
  SupervisorBookingStatus
} from '../../supervisor-booking/supervisor-booking'
import { supervisorBookingSelectors } from '../../supervisor-booking/supervisor-booking.selectors'
import { SupervisorBookingService } from '../../supervisor-booking/supervisor-booking.service'
import { supervisorSkillsSelectors } from '../../supervisor-skills/supervisor-skills.selectors'
import { Booking } from '../booking'
import { bookingSelectors } from '../booking.selectors'
import { productSelectors } from '../../product/product.selectors'
import { participationSelectors } from '../participation/participation.selectors'
import { ParticipationService } from '../participation/participation.service'
import { TranslateService } from '@ngx-translate/core'
import { EmployeeContract } from '../../employee-contract/employee-contract'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { Router } from '@angular/router'

import { employeeBookingSelectors } from '../../employee-booking/employee-booking.selectors'

import { BookingService } from '../booking.service'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { EmployeeBookingService } from '../../employee-booking/employee-booking.service'
import { EmployeeContractService } from '../../employee-contract/employee-contract.service'
import { SupervisorSkillsService } from '../../supervisor-skills/supervisor-skills.service'

import { tagActions } from '../../tag/tag.actions'
import { memberActions } from '../../member/member.actions'
import { SupervisorSkills } from '../../supervisor-skills/supervisor-skills'

import { bookingActions } from '../booking.actions'
import { supervisorSkillsActions } from '../../supervisor-skills/supervisor-skills.actions'
import { employeeContractSelectors } from '../../employee-contract/employee-contract.selectors'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'
import { SupervisorBookingContractSelectionModal } from '../supervisor-tab/confirm-employee-booking-creation-modal/show.component'
import { SupervisorSerieIdChangeConfirmModalComponent } from '../supervisor-tab/supervisor-serie-id-change-confirm-modal/supervisor-serie-id-change-confirm-modal.component'
import { timeBlockActions } from '../../time-block/time-block.actions'
import { TimeBlockType } from '../../time-block/time-block'

interface SelectedBulActions {
  dateRange: string
  action: any
  startDate: any
  endDate: any
  arraySupervisor: any[]
}

@UntilDestroy()
@Component({
  selector: 'booking-supervisor-assign',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class BookingSupervisorAssignComponent implements OnInit, OnDestroy {
  @Input() customTitle: string
  @Input() formCreate: any
  @Input() isRepeat: any
  @Input() showButtonsInsteadBulkActions: boolean = false
  @Input() showCancelButtonInModalVersion: boolean = false

  public supervisorAssign: SelectedBulActions = {
    dateRange: null,
    action: null,
    startDate: null,
    endDate: null,
    arraySupervisor: []
  }
  public booking$: Observable<Partial<Booking>>
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  )
  public isLoadingRelations: boolean = false
  public membersEntities$: Observable<Dictionary<Member>> = this.store.select(
    memberSelectors.selectEntities
  )
  public bookingId$: Observable<number>
  public isLoadingSvB$: Observable<boolean>
  public isLoadingSvS$: Observable<boolean>

  public memberLoading$ = this.store.select(memberSelectors.selectIsLoading)
  public totalCalls = 0
  public totalCallsMade = 0
  public supervisorRequiered$: Observable<any>
  public supervisorData$: Observable<SupervisorBooking[]>
  private supervisorSkills$: BehaviorSubject<SupervisorSkills[]> =
    new BehaviorSubject<SupervisorSkills[]>([])
  public bookingEntitiesOfToday: Object = {}
  private dateRangeSerieSelected: string = 'future'
  public BulkAction = BulkAction
  public selectedContract: number
  public supervisorBooking: any
  private allowedProducts: any[] = []
  private subscriptions: Subscription[] = []
  public displayStyle = 'none'
  public member$: Observable<Member>
  private showSuccessNotification: boolean = true
  public displayAttachMode: boolean = false
  public calculatedSupervisor: number = 0
  public totalSupervisorSelected: number = 0
  public supervisorsIds: number[] = []
  public booking: Partial<Booking>
  private totalSupervisorsSkillIds: number[] = []
  public loadingColor = 'text-secondary'
  public attachLoading: boolean = false
  public wantCalculationHours$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false)
  public wantShowSchedule$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false)
  private totalSupervisorFetched: number[] = []
  public hardRefreshInComponent = false
  @ViewChild('modalProcessing') modal: ElementRef
  subscription: Subscription
  constructor(
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private participationService: ParticipationService,
    public configurationService: ConfigurationService,
    public supervisorBookingService: SupervisorBookingService,
    public employeeBookingService: EmployeeBookingService,
    public employeeContractService: EmployeeContractService,
    public supervisorSkillsService: SupervisorSkillsService,
    public memberService: MemberService,
    private modalService: BsModalService,
    public roundMinutes: RoundMinutesPipe,
    public bookingService: BookingService,
    private changeDetectorRef: ChangeDetectorRef,
    public router: Router
  ) {
    if (this.router.getCurrentNavigation()?.id == 1) {
      this.hardRefreshInComponent = true
    }
  }
  public cancel() {
    this.bsModalRef.hide()
  }
  ngOnInit() {
    this.store.dispatch(tagActions.fetchMany({}))
    this.member$ = this.store.select(authSelectors.selectMember)
    this.isLoadingSvB$ = this.store
      .select(supervisorBookingSelectors.selectIsLoading)
      .pipe(startWith(false))
    this.isLoadingSvS$ = this.store
      .select(supervisorSkillsSelectors.selectIsLoading)
      .pipe(startWith(false))
    this.makeProvisionalBooking()
    this.supervisorData$ = combineLatest([
      this.store.select(supervisorBookingSelectors.selectAll),
      this.supervisorSkills$,
      this.store.select(bookingSelectors.selectEntities),
      this.booking$,
      this.membersEntities$,
      this.store.select(employeeBookingSelectors.selectAll),
      this.store.select(bookingSelectors.selectAll)
    ]).pipe(
      distinctUntilChanged((a, b) => {
        return JSON.stringify(a) == JSON.stringify(b)
      }),
      map(
        ([
          supervisorsBooking,
          supervisorSkills,
          bookingEntities,
          booking,
          membersEntities,
          employeeBookings,
          allBookings
        ]: any) => {
          this.isLoading$.next(false)
          if (!supervisorSkills || supervisorSkills.length === 0) {
            this.isLoading$.next(true)
            return
          }
          this.setBookingsOfTheSameDayOfBooking(booking, bookingEntities)
          const supervisorsAllowed = this.supervisorsAllowed(
            supervisorSkills,
            booking,
            this.allowedProducts
          )

          let bookingsArray = []
          for (const bk of Object.keys(this.bookingEntitiesOfToday)) {
            for (const svId of supervisorsAllowed) {
              if (!this.totalSupervisorFetched.includes(svId)) {
                this.totalSupervisorFetched.push(svId)
                this.fetchTimeBlocksOfMember(svId)
              }
              const supervisorBookingsMapped = supervisorsBooking.filter(
                (supervisorBooking) =>
                  supervisorBooking.bookingId === Number(bk) &&
                  supervisorBooking.personId === svId
              )
              if (supervisorBookingsMapped.length > 0) {
                for (const sm of supervisorBookingsMapped) {
                  bookingsArray.push({
                    //id: number
                    bookingId: Number(sm.bookingId),
                    personId: sm.personId,
                    status: sm.status,
                    createdAt: sm.createdAt,
                    product: bookingEntities[sm.bookingId]?.product,
                    booking: bookingEntities[sm.bookingId],
                    linkedProduct:
                      bookingEntities[sm.bookingId]?.linkedProductId,
                    member: membersEntities[svId],
                    supervisorBookingId: sm.id,
                    isPrivate: sm.isPrivate
                  })
                }
              } else if (supervisorBookingsMapped.length == 0) {
                bookingsArray.push({
                  bookingId: Number(bk),
                  personId: svId,
                  status: null,
                  createdAt: null,
                  product: this.bookingEntitiesOfToday[bk]?.product,
                  booking: this.bookingEntitiesOfToday[bk],
                  linkedProduct:
                    this.bookingEntitiesOfToday[bk]?.linkedProductId,
                  member: membersEntities[svId]
                })
              }
            }
          }
          setTimeout(() => {
            this.isLoading$.next(true)
          }, 500)

          this.isLoadingRelations = false
          return bookingsArray.sort((a, b) =>
            a.personId > b.personId ? -1 : 1
          )
        }
      )
    )

    if (this.formCreate) {
      this.allowedProducts = []
      if (!!this.formCreate.allowedLinkedProductIds) {
        typeof this.formCreate.allowedLinkedProductIds == 'number'
          ? (this.allowedProducts = [
              ...this.allowedProducts,
              this.formCreate.allowedLinkedProductIds
            ])
          : (this.allowedProducts = [
              ...this.allowedProducts,
              ...this.formCreate.allowedLinkedProductIds
            ])
      }
      if (!!this.formCreate.linkedProductId) {
        typeof this.formCreate.linkedProductId == 'number'
          ? (this.allowedProducts = [
              ...this.allowedProducts,
              this.formCreate.linkedProductId
            ])
          : (this.allowedProducts = [
              ...this.allowedProducts,
              ...this.formCreate.linkedProductId
            ])
      }
      if (!!this.formCreate.productIds) {
        typeof this.formCreate.productIds == 'number'
          ? (this.allowedProducts = [
              ...this.allowedProducts,
              this.formCreate.productIds
            ])
          : (this.allowedProducts = this.allowedProducts =
              [...this.allowedProducts, ...this.formCreate.productIds])
      }
      if (this.allowedProducts.length > 0) {
        this.allowedProducts = [...new Set(this.allowedProducts)]
        this.loadFirstData()
      }
    }

    this.supervisorRequiered$ = combineLatest([
      this.booking$,
      this.store.select(productSelectors.selectEntities),
      this.store.select(participationSelectors.selectEntities)
    ]).pipe(
      filter(([booking, products, participations]) =>
        Array.isArray(booking?.participations)
      ),
      map(([booking, products, participations]) => {
        return this.howManySupervisorAreRequired(
          booking,
          products,
          participations
        )
      })
    )
  }
  private fetchTimeBlocksOfMember(memberId: number) {
    this.store.dispatch(timeBlockActions.resetState())

    this.store.dispatch(
      timeBlockActions.fetchManyByItemTypeAndId({
        itemId: memberId,
        timeBlockType: TimeBlockType.MEMBER
      })
    )
  }
  private makeProvisionalBooking() {
    this.booking$ = of({
      id: -99999999999999,
      startDate: moment(this.formCreate.startDate).toISOString(),
      endDate: moment(this.formCreate.endDate).toISOString(),
      linkedProductId: this.formCreate.linkedProductId,
      productId: this.formCreate.productIds,
      allowedLinkedProductIds: this.formCreate.allowedLinkedProductIds
    })
    this.booking$.pipe(take(1)).subscribe((booking) => (this.booking = booking))
  }

  private continueBulkAction(
    bulkAction: BulkActionEvent,
    booking: Partial<Booking>,
    withSerie: boolean
  ) {
    switch (bulkAction.action) {
      case BulkAction.INVITE:
      case BulkAction.ATTACH: {
        let entitiesSelectedInBulkAction = []
        bulkAction.items.forEach((itemSelected: any) => {
          entitiesSelectedInBulkAction.push({
            personId: itemSelected.id,
            supervisorInfo: itemSelected,
            status:
              bulkAction.action == BulkAction.INVITE
                ? SupervisorBookingStatus.INVITED
                : SupervisorBookingStatus.ACCEPTED
          })
        })
        this.createSupervisorBookings(
          entitiesSelectedInBulkAction,
          bulkAction.action
        )

        break
      }
    }
  }
  private createSupervisorBookings(supervisorBookings: any[], action: any) {
    this.showSuccessNotification = false
    this.store
      .select(employeeContractSelectors.selectAll)
      .pipe(
        withLatestFrom(
          this.store.select(bookingSelectors.selectEntities),
          this.store.select(supervisorBookingSelectors.selectEntities)
        ),
        take(1)
      )
      .subscribe(([employeeContracts, bookingEntities]: any) => {
        this.totalSupervisorSelected = supervisorBookings.length
        const contractsOfSupervisors = employeeContracts?.filter(
          (employeeContract) =>
            supervisorBookings
              .map((supervisorBooking) => supervisorBooking.personId)
              .includes(employeeContract.personId)
        )
        const supervisorBookingsWithoutActiveContract =
          this.getSupervisorBookingContract(
            false,
            supervisorBookings,
            contractsOfSupervisors,
            bookingEntities
          )
        const supervisorBookingsWithActiveContract =
          this.getSupervisorBookingContract(
            true,
            supervisorBookings,
            contractsOfSupervisors,
            bookingEntities
          )
        if (
          supervisorBookingsWithActiveContract?.length > 0 ||
          supervisorBookingsWithoutActiveContract?.length > 0
        ) {
          this.totalCalls = 0
          this.totalCallsMade = 0
          this.displayStyle = 'block'
          this.displayAttachMode = true

          const modalRef = this.modalService.show(
            SupervisorBookingContractSelectionModal,
            {
              initialState: {
                employeeContracts:
                  supervisorBookingsWithActiveContract?.length > 0
                    ? this.getActiveContractOfSupervisor(
                        contractsOfSupervisors,
                        supervisorBookingsWithActiveContract,
                        bookingEntities
                      )
                    : [],
                supervisorBookingsWithActiveContract:
                  supervisorBookingsWithActiveContract,
                supervisorBookingsWithoutActiveContract:
                  supervisorBookingsWithoutActiveContract
              },
              class: 'modal-lg modal-dialog-centered',
              backdrop: 'static',
              animated: true
            }
          )
          modalRef.onHide
            .pipe(
              take(1),
              withLatestFrom(
                this.store.select(
                  persistentUserRoleSelectors.selectSelectedUserRole
                )
              )
            )
            .subscribe(([event, pUr]) => {
              if (modalRef.content.isCancel) {
                this.displayStyle = 'none'
                this.totalCalls = 0
                this.totalCallsMade = 0
                this.displayAttachMode = false
                this.isLoading$.next(true)
                return
              }
              let arraySupervisor = []
              modalRef.content.form.controls['spvWcontrats']?.value?.forEach(
                (element) => {
                  delete element.contracts
                  arraySupervisor.push(element)
                }
              )
              modalRef.content.form.controls['spvWOcontrats']?.value?.forEach(
                (element) => {
                  arraySupervisor.push({
                    ...element,
                    generateEmployeeBooking: false,
                    seletedContract: null
                  })
                }
              )

              this.supervisorAssign = {
                dateRange: this.isRepeat ? this.dateRangeSerieSelected : null,
                action: action,
                arraySupervisor: arraySupervisor,
                startDate: this.formCreate.startDate,
                endDate: this.formCreate.endDate
              }

              this.bsModalRef.hide()
            })
        } else {
          this.supervisorAssign = {
            dateRange: this.isRepeat ? this.dateRangeSerieSelected : null,
            action: action,
            arraySupervisor: [],
            startDate: this.formCreate.startDate,
            endDate: this.formCreate.endDate
          }
        }
      })
  }

  private getActiveContractOfSupervisor(
    contractsOfSupervisors: any[],
    supervisorBookingsWithActiveContract: any[],
    bookingEntities: Dictionary<Booking>
  ) {
    let activeContractsOfSupervisor: EmployeeContract[] = []
    for (const supervisorBooking of supervisorBookingsWithActiveContract) {
      activeContractsOfSupervisor = [
        ...activeContractsOfSupervisor,
        ...contractsOfSupervisors.filter(
          (employeeContract) =>
            employeeContract.personId == supervisorBooking.personId &&
            moment(employeeContract.startDate).isSameOrBefore(
              moment(
                bookingEntities[supervisorBooking.bookingId]?.startDate ??
                  this.booking?.startDate
              )
            ) &&
            (!employeeContract.endDate ||
              moment(employeeContract.endDate).isSameOrAfter(
                moment(
                  bookingEntities[supervisorBooking.bookingId]?.endDate ??
                    this.booking?.endDate
                )
              ))
        )
      ]
    }
    return activeContractsOfSupervisor
  }
  private getSupervisorBookingContract(
    active: boolean,
    supervisorBookings: any[],
    contractsOfSupervisors: any,
    bookingEntities: Dictionary<Booking>
  ) {
    let contractsFound = []
    if (!active) {
      contractsFound = supervisorBookings.filter(
        (supervisorBooking) =>
          !Boolean(
            contractsOfSupervisors.find(
              (contract) =>
                contract.personId == supervisorBooking.personId &&
                moment(contract.startDate).isSameOrBefore(
                  moment(
                    bookingEntities[supervisorBooking.bookingId]?.startDate ??
                      this.booking?.startDate
                  )
                ) &&
                (!contract.endDate ||
                  moment(contract.endDate).isSameOrAfter(
                    moment(
                      bookingEntities[supervisorBooking.bookingId]?.endDate ??
                        this.booking?.endDate
                    )
                  ))
            )
          )
      )
    } else {
      contractsFound = supervisorBookings.filter((supervisorBooking) =>
        contractsOfSupervisors.find(
          (contract) =>
            contract.personId == supervisorBooking.personId &&
            moment(contract.startDate).isSameOrBefore(
              moment(
                bookingEntities[supervisorBooking.bookingId]?.startDate ??
                  this.booking?.startDate
              )
            ) &&
            (!contract.endDate ||
              moment(contract.endDate).isSameOrAfter(
                moment(
                  bookingEntities[supervisorBooking.bookingId]?.endDate ??
                    this.booking?.endDate
                )
              ))
        )
      )
    }
    return contractsFound
  }
  public onBulkAction(bulkAction: BulkActionEvent) {
    this.supervisorAssign = {
      dateRange: null,
      action: null,
      startDate: null,
      endDate: null,
      arraySupervisor: []
    }
    if (!bulkAction.items || bulkAction.items.length == 0) {
      return
    }
    this.booking$
      .pipe(
        take(1),
        untilDestroyed(this),
        withLatestFrom(
          this.store.select(bookingSelectors.selectEntities),
          this.store.select(supervisorBookingSelectors.selectEntities)
        )
      )
      .subscribe(([booking, bookingEntities, supervisorBookings]) => {
        if (this.isRepeat) {
          const modalRef = this.modalService.show(
            SupervisorSerieIdChangeConfirmModalComponent,
            {
              initialState: {
                supervisorBookingsSelected: bulkAction.items?.length,
                message: 'employeeModule.doYouWantToExtendToBookingsSeries',
                showError: false
              },
              class: 'modal-md  modal-dialog-centered',
              backdrop: 'static'
            }
          )
          modalRef.onHide.pipe(take(1)).subscribe((event) => {
            if (modalRef.content.isCancel) {
              this.isLoading$.next(true)
              return
            }
            if (
              modalRef.content.wantToGenerateBookingSeries &&
              modalRef.content.dateRange === 'future'
            ) {
              this.dateRangeSerieSelected = 'future'
            } else if (
              modalRef.content.wantToGenerateBookingSeries &&
              modalRef.content.dateRange === 'all'
            ) {
              this.dateRangeSerieSelected = 'all'
            } else {
              this.dateRangeSerieSelected = null
            }
            this.continueBulkAction(bulkAction, booking, this.isRepeat)
          })
        } else {
          this.continueBulkAction(
            bulkAction,
            booking,

            this.isRepeat
          )
        }
      })
  }
  private setBookingsOfTheSameDayOfBooking(
    booking: Partial<Booking>,
    bookingEntities: Dictionary<Booking>
  ) {
    Object.values(bookingEntities)
      .filter((b: any) => {
        return (
          moment(b.startDate).format('YYYY-MM-DD') ===
            moment(booking.startDate).format('YYYY-MM-DD') &&
          moment(b.endDate).format('YYYY-MM-DD') ===
            moment(booking.endDate).format('YYYY-MM-DD')
        )
      })
      .forEach((bookingsToday: any) => {
        this.bookingEntitiesOfToday[bookingsToday.id] =
          bookingEntities[bookingsToday.id]
      })
    this.bookingEntitiesOfToday[booking.id] = booking
  }
  private supervisorsAllowed(
    supervisorSkills: SupervisorSkills[],
    booking: Partial<Booking>,
    productsAllowed
  ) {
    return [
      ...new Set(
        supervisorSkills
          ?.filter(
            (sv) =>
              productsAllowed.includes(sv.productId) ||
              sv.productId === booking.productId
          )
          .map((item) => item.personId)
      )
    ]
  }

  private howManySupervisorAreRequired(booking, products, participations) {
    const allowedLinkedProductsSupervisorRequires =
      this.getRequiresSupervisorOfAllowedProducts(booking, products)
    if (!booking.linkedProductId) {
      if (!booking.productId) {
        return Number(0)
      }
      return products[booking.productId]?.requiresSupervisor
        ? Number(products[booking.productId]?.requiresSupervisor)
        : Number(allowedLinkedProductsSupervisorRequires)
    } else {
      if (products[booking.linkedProductId]?.maxParticipantsPerSupervisor) {
        const participantionBokking: any =
          this.participationService.getParticipationPerInviter(
            booking?.participations?.map((pId) => participations[pId])
          )
        let maxSupervisors = 0
        participantionBokking.map((sp) => {
          const participantionBokkingReduce: any =
            participantionBokking.reduce((a, b) => {
              return a + b?.count
            }, 0) -
            participantionBokking.reduce((a, b) => {
              return a + b?.chaperons
            }, 0)

          maxSupervisors = Number(
            Math.ceil(
              participantionBokkingReduce /
                products[booking.linkedProductId]?.maxParticipantsPerSupervisor
            )
          )
        })
        return maxSupervisors
      } else {
        return products[booking.linkedProductId]?.requiresSupervisor
          ? Number(products[booking.linkedProductId]?.requiresSupervisor)
          : Number(allowedLinkedProductsSupervisorRequires)
      }
    }
  }
  public onWantShowSchedule(showSchedule) {
    this.wantShowSchedule$.next(showSchedule)
  }
  public makeCalculationHours(wantCalculationHours) {
    this.wantCalculationHours$.next(wantCalculationHours)
    this.wantCalculationHours$
      .pipe(take(1))
      .subscribe((wantCalculationHours) => {
        if (wantCalculationHours) {
          this.booking$ = this.bookingId$.pipe(
            switchMap((bookingId) =>
              this.store.select(bookingSelectors.selectById, bookingId)
            ),
            filter((b) => Boolean(b))
          )
        }
      })
  }

  private getRequiresSupervisorOfAllowedProducts(booking, products): number {
    let supervisorRequires: number = 0
    booking.allowedLinkedProducts?.map((product) => {
      supervisorRequires =
        Number(products[product]?.requiresSupervisor) > supervisorRequires &&
        Number(products[product]?.requiresSupervisor)
    })
    return Number(supervisorRequires)
  }
  private loadFirstData() {
    this.store.dispatch(supervisorSkillsActions.actionFinishedReset())
    this.store.dispatch(
      supervisorSkillsActions.getAllMany({
        params: RequestQueryBuilder.create({
          search: {
            productId: { [CondOperator.IN]: this.allowedProducts }
          }
        })
      })
    )
    this.store
      .select(supervisorSkillsSelectors.selectActionFinished)
      .pipe(
        first(
          (itemAction) =>
            itemAction !== null &&
            itemAction.action == supervisorSkillsActions.getAllMany.type
        )
      )
      .subscribe((itemAction) => {
        let supervisorSkills = itemAction.data
        if (!supervisorSkills || supervisorSkills.length == 0) {
          this.supervisorSkills$.next([])
          return
        }
        this.supervisorSkills$.next(supervisorSkills)

        const personIds: any = [
          ...new Set(supervisorSkills.map((item) => item.personId))
        ]

        if (personIds.length == 0) {
          return
        }
        this.totalSupervisorsSkillIds = personIds
        this.supervisorsIds = personIds
        this.fetchMembers(personIds)
        this.store.dispatch(memberActions.actionFinishedReset())
        this.store
          .select(memberSelectors.selectActionFinished)
          .pipe(
            first(
              (itemAction) =>
                itemAction !== null &&
                itemAction.action == memberActions.fetchMany.type
            )
          )
          .subscribe((itemAction) => {
            this.attachLoading = true
            this.memberService.normalizeData(itemAction.data)

            this.fetchGetAllEmployeeRelations(personIds)
          })
      })
  }

  private fetchGetAllEmployeeRelations(personIds: number[]) {
    this.store.dispatch(bookingActions.actionFinishedReset())

    this.store.dispatch(
      bookingActions.getAllEmployeeRelations({
        data: {
          withSerie: true,
          startDate: moment(this.formCreate.startDate).toISOString(),
          endDate: moment(this.formCreate.endDate).toISOString(),
          personIds:
            this.totalSupervisorsSkillIds.length > 0
              ? this.totalSupervisorsSkillIds
              : personIds,
          type: null
        }
      })
    )
    this.store
      .select(bookingSelectors.selectActionFinished)
      .pipe(
        first(
          (itemAction) =>
            itemAction !== null &&
            itemAction.action == bookingActions.getAllEmployeeRelations.type
        )
      )
      .subscribe((itemAction) => {
        this.isLoading$.next(true)
        this.attachLoading = false
        this.bookingService.upsertManyData(itemAction.data)
      })
  }
  private fetchMembers(personIds: number[]) {
    if (personIds?.length > 0) {
      this.attachLoading = false
      this.store.dispatch(
        memberActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              id: { [CondOperator.IN]: [...personIds] }
            },
            join: [{ field: 'tags' }, { field: 'supervisorSkills' }]
          })
        })
      )
      this.store.dispatch(
        bookingActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              'supervisorBookings.personId': {
                [CondOperator.IN]: [...personIds]
              },
              endDate: {
                [CondOperator.GREATER_THAN_EQUALS]: this.formCreate.startDate
              }
            },
            join: [
              { field: 'supervisorBookings' },
              { field: 'supervisors' },
              { field: 'employeeBookings' }
            ]
          })
        })
      )
      this.store.dispatch(
        employeeBookingActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              personId: { [CondOperator.IN]: [...personIds] },
              endDate: {
                [CondOperator.GREATER_THAN_EQUALS]: this.formCreate.startDate
              }
            }
          })
        })
      )
    }
  }

  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
